<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索柜子"
                   v-model="pageInfo.shopName">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>
        <div class="flex1 posi-rel pb-250">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div class="cabin click" v-for="(item,$index) in data" :key="$index" @click="getScrollerPosition();$router.push({name:'equipmentHome',query:{shopId:item.shopId}})">
                    <div class="fs-36 color-333 flex-center pd-250 bd-bot">
                        <div class="supply-label" v-if="item.shopType == '1'">{{equipment_type[item.equipmentType]}}</div>
                        <div class="supply-label" v-if="item.shopType == '2'">{{equipment_type['huodong']}}</div>
                        <div class="font-bold">{{item.shopName}}</div></div>
                    <div class="fs-30 color-999 address">{{item.address}}</div>
                </div>
            </scroller>

        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    export default {
        name: "equipmentList",
        mixins: [initData, routerBack, getAppStatusHeight],
        components: {appStatus},
        data(){
            return{
                equipment_type: {
                    spring: '弹簧柜',
                    rfid: 'RFID柜',
                    consign: '格子柜',
                    weigh: '称重柜',
                    huodong:'活动店铺'

                },
            }
        },
        methods:{
            back() {
                if (this.isBackClose) {
                    try {
                        window.native.onFinish();
                    } catch (e) {

                    }
                } else {
                    try {
                        window.native.onBack();
                    } catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                this.params = { page : this.page, limit: this.limit}
                this.url = 'shop/shopInfo/selectMyShop'
                let query = this.pageInfo
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                return true
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == 'equipmentHome') {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack) {
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .cabin{
        background: #fff;
        margin: .2rem .24rem;
        border-radius: .12rem;
    }
    .address{
        padding: .2rem;
    }
</style>



// WEBPACK FOOTER //
// equipmentList.vue?b507e988